"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBankAccountNR = void 0;
const validateBankAccountNR = (bank_account, selectedPostalCode, required = true) => {
    if (!required && !bank_account.length) {
        return true;
    }
    switch (selectedPostalCode) {
        case 'dk':
            // Danish validation: 4-digit registration number + 10-digit account number
            return /^\d{14}$/.test(bank_account);
        default:
            const noWeights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
            // Norwegian validation: (MOD11)
            if ((bank_account === null || bank_account === void 0 ? void 0 : bank_account.length) === 11) {
                const checkDigit = parseInt(bank_account.charAt(10), 10);
                const withoutCheckDigit = bank_account.substring(0, 10);
                let sum = 0;
                for (let i = 0; i < 10; i++) {
                    sum += parseInt(withoutCheckDigit.charAt(i), 10) * noWeights[i];
                }
                const remainder = sum % 11;
                return checkDigit === (remainder === 0 ? 0 : 11 - remainder);
            }
            return false;
    }
};
exports.validateBankAccountNR = validateBankAccountNR;
//# sourceMappingURL=validateBankAccountNr.js.map